import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatNativeDateModule } from '@angular/material/core';
import { OrderConfirmDialogComponent } from 'src/app/features/service-order/confirm-preliminary/ui/order-confirm-dialog/order-confirm-dialog.component';
import { CreateOrderComponent } from 'src/app/features/service-order/create-order/ui/create-order/create-order.component';
import { DialogDeleteOSComponent } from 'src/app/features/service-order/delete-service-order/ui/dialog-delete-os/dialog-delete-os.component';
import { OrderFreezeDeadlineDialogComponent } from 'src/app/features/service-order/edit-freeze-deadline/ui/order-freeze-deadline-dialog/order-freeze-deadline-dialog.component';
import { DialogEditFechaPagoProgramadaComponent } from 'src/app/features/service-order/edit-scheduled-payment-date/ui/dialog-edit-fecha-pago-programada/dialog-edit-fecha-pago-programada.component';
import { OrderPdfDialogComponent } from 'src/app/features/service-order/order-pdf/ui/order-pdf-dialog/order-pdf-dialog.component';
import { OrderRecalcHistoryDialogComponent } from 'src/app/features/service-order/recalc-history/ui/order-recalc-history-dialog/order-recalc-history-dialog.component';
import { SharedModule } from '../pipes/shared.module';
import { CuadroPicnicComponent } from './cuadro-picnic.component';
import { DialogPicnicDetailsComponent } from './dialog-picnic-details/dialog-picnic-details.component';
import { DialogProviderMultipleComponent } from './dialog-provider-multiple/dialog-provider-multiple.component';
import { ServiciosOperativosModalComponent } from './servicios-operativos-modal/servicios-operativos-modal.component';

@NgModule({
  declarations: [
    CuadroPicnicComponent,
    DialogPicnicDetailsComponent,
    ServiciosOperativosModalComponent,
    DialogProviderMultipleComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TablerIconsModule,
    MatSortModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatBadgeModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatIconModule,
    CreateOrderComponent,
    OrderPdfDialogComponent,
    DialogDeleteOSComponent,
    DialogEditFechaPagoProgramadaComponent,
    OrderConfirmDialogComponent,
    OrderFreezeDeadlineDialogComponent,
    OrderRecalcHistoryDialogComponent,
  ],
})
export class CuadroPicnicModule {}
